import React, { useEffect, useState } from "react";
import SingleTogglePopup from "./SingleTogglePopup";
import SelectedUserList from "./SelectedUserList";
import styled from "styled-components";
import SingleUserModal from "./SingleUserModal";
import { useTranslation } from "react-i18next";

const AddSingleUser = ({
  mainParents,
  title,
  icon,
  selPlaceholder,
  setSelectedItem,
  selectedItem,
  //   onUserAdd,
}) => {
  const { t } = useTranslation();
  const [selectedMainParents, setSelectedMainParents] = useState([]);
  const [pendingSelection, setPendingSelection] = useState(null);
  const [showSingleUserModal, setShowSingleUserModal] = useState(false);

  const handleAddUserClick = () => {
    if (pendingSelection) {
      //   onUserAdd(pendingSelection);
      setSelectedItem(pendingSelection.id);
      setSelectedMainParents([pendingSelection]);
      setShowSingleUserModal(false);
    }
  };

  const handleRemoveClick = () => {
    setSelectedMainParents([]);
    setPendingSelection(null);
    setSelectedItem(null);
  };
  useEffect(() => {
    if (selectedItem && mainParents.length > 0) {
      const selectedItm = mainParents.find(
        (item) => parseInt(item.id) === parseInt(selectedItem)
      );

      setSelectedMainParents([selectedItm]);
    }
  }, [selectedItem]);
  

  return (
    <SingleUserRow>
      {selectedMainParents.length === 0 ? (
        <>
          <SingleTogglePopup
            icon={icon}
            selPlaceholder={t(selPlaceholder)}
            setShowSingleUserModal={setShowSingleUserModal}
          />
          <SingleUserModal
            title={t(title)}
            show={showSingleUserModal}
            onHide={() => setShowSingleUserModal(false)}
            mainParents={mainParents}
            pendingSelection={pendingSelection}
            setPendingSelection={setPendingSelection}
            handleAddUserClick={handleAddUserClick}
          />
        </>
      ) : (
        <SelectedUserList
          selectedMainParents={selectedMainParents}
          onRemoveClick={handleRemoveClick}
        />
      )}
    </SingleUserRow>
  );
};

export default AddSingleUser;

const SingleUserRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
